function removeopup() {
    var doek = document.getElementById('doek');
    var popup = document.getElementById('popup');
    if (popup) {
        doek.removeChild(popup);
    }

}